import { useTranslation } from 'react-i18next'
import type { DtsConverterDto } from '@dhl/mdp-api'
import { DataWrapper, DataRow, DataAside } from '~/modules/ppp/submodules/relations/components/data'
import { CommonProperties } from '~/modules/ppp/submodules/relations/components/common/CommonProperties'
import { presentDateOrDefault } from '~/modules/ppp/submodules/relations/utils'

type Props = {
  connector: DtsConverterDto
}
export const Converter = ({ connector }: Props) => {
  const { t } = useTranslation()

  return (
    <DataWrapper>
      <DataRow title="createdOn" payload={presentDateOrDefault(connector.createdOn)} />
      <DataRow title="createdBy" payload={connector.createdBy} withCopy />
      <DataRow title="flowName" payload={connector.flowName} withCopy />
      <DataRow title="converterImplementation" payload={connector.converterImplementation} withCopy />
      <DataRow title="converterJob" payload={connector.converterJob} withCopy />
      {connector.properties && Object.keys(connector.properties).length > 0 ? (
        <CommonProperties prefix="converter" properties={connector.properties} />
      ) : (
        <DataAside message={t('admin.pppRelationsPage.noProperties')} />
      )}
    </DataWrapper>
  )
}
